export default "__VITE_ASSET__DqnoXofX__"